<template>
  <div class="row">
    <div class="col-xl-6 col-lg-12">
      <card class="card-user">
        <template slot="header">
          <h4 class="card-title">{{ $t('profile.title') }}</h4>
        </template>
        <div class="author">
          <div class="block block-one"></div>
          <!--        <div class="block block-two"></div>-->
          <div class="block block-three"></div>
          <div class="block block-four"></div>
        </div>
        <div>
          <table class="table-sm">
            <tr>
              <td><label>{{ $t('generic.id') }}:</label></td>
              <td class="pl-2">{{ details.id }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.username') }}:</label></td>
              <td class="pl-2">{{ details.username }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.first_name') }}:</label></td>
              <td class="pl-2">{{ details.first_name }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.last_name') }}:</label></td>
              <td class="pl-2">{{ details.last_name }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.role') }}:</label></td>
              <td class="pl-2">{{ details.role }}</td>
            </tr>
            <tr v-if="details.inspector_team_id">
              <td><label>{{ $t('profile.details.inspector_team_id') }}:</label></td>
              <td class="pl-2">
                <router-link :to="inspectorTeamLink()">{{ details.inspector_team_id }}</router-link>
              </td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.assigned_operators') }}:</label></td>
              <td class="pl-2">
                <assigned-operators-table :data="details.assigned_operators"/>
              </td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.permissions') }}:</label></td>
              <td class="pl-2">
                <permissions-table :roles="[details.role]" :permissions="details.permissions"/>
              </td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.last_login_at') }}:</label></td>
              <td class="pl-2">{{ details.last_login_at | time }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('profile.details.role_metadata') }}:</label></td>
              <td class="pl-2"><meta-data-details :data="details.role_metadata"/></td>
            </tr>
          </table>
          <div class="button-container mt-3">
            <div class="row">
              <div class="col-4">
                <password-change-btn :system-account-id="details.ID"/>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import PermissionsTable from "src/components/Permissions/PermissionsTable";
  import AssignedOperatorsTable from "src/components/Operator/AssignedOperatorsTable";
  import PasswordChangeBtn from './PasswordChangeBtn';
  import linkUtils from "@/util/link_utils";
  import BaseTable from "@/components/BaseTable.vue";
  import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

  export default {
    name: 'profile',
    components: {
      MetaDataDetails,
      BaseTable,
      PermissionsTable,
      AssignedOperatorsTable,
      PasswordChangeBtn
    },
    computed: {
      details: function () {
        return this.$auth.user();
      }
    },
    methods: {
      inspectorTeamLink() {
        return linkUtils.inspectorTeamPath(this.$router,{inspector_team_id: this.details.inspector_team_id});
      }
    }
  };
</script>
<style></style>
